// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Security Logs — scoped .slg-* */

.slg-page {
  width: 100%;
  min-height: 100%;
  padding: 35px 24px 48px;
  max-width: 1200px;
  margin: 0 auto;
}

.slg-page *,
.slg-page *::before,
.slg-page *::after {
  box-sizing: border-box;
}

.slg-page__crumbs {
  margin-bottom: 18px;
}

.slg-page__crumbList {
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #8e939c;
  font-size: 15px;
  font-weight: 500;
}

.slg-page__crumbItem--active {
  color: #e1e1e1;
}

body.light_theme .slg-page__crumbItem--active {
  color: #101828;
}

.security_section_bl {
  padding-top: 40px;
  padding-left: 30px;
}

.slg-page__crumbSep {
  color: #8e939c;
}

.slg-page__crumbLink {
  border: none;
  background: transparent;
  padding: 0;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

.slg-page__title {
  margin: 0 0 20px;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #e4e4e4;
}

body.light_theme .slg-page__title {
  color: #101828;
}

.slg-page__sub {
  margin: 0 0 20px;
  font-size: 14px;
  font-weight: 500;
  color: #8e939c;
  line-height: 1.5;
  max-width: 720px;
}

.slg-page__title+.slg-page__sub {
  margin-top: -10px;
}

.slg-tabs {
  display: flex;
  gap: 32px;
  margin-bottom: 0;
}

.slg-tab {
  border: none;
  background: transparent;
  padding: 0 0 5px;
  margin-bottom: 18px;
  font-size: 15px;
  font-weight: 500;
  color: #84888C;
  cursor: pointer;
  border-bottom: none;
  position: relative;
}

.slg-tab::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 24px;
  margin: 0 auto;
  left: 0;
  opacity: 0;
  right: 0px;
  height: 2px;
  background: #fff;
}

body.light_theme .slg-tab::before {
  background: #101828;
}

.slg-tab:hover {
  color: #6b7280;
}

.slg-tab.is-active {
  color: #e6e6e6;
  font-weight: 600;
}

body.light_theme .slg-tab.is-active {
  color: #101828;
}

.slg-tab.is-active::before {
  opacity: 1;
}

.slg-tableWrap {
  margin-top: 0;
  background: #171a20;
  overflow: hidden;
}

body.light_theme .slg-tableWrap {
  background: #fff;
}

.slg-tableScroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.slg-table {
  width: 100%;
  min-width: 880px;
  border-collapse: collapse;
  table-layout: auto;
  font-size: 14px;
}

.slg-table thead th {
  padding: 14px 16px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: #9ca3af;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  border-bottom: 1px solid #eef2f6;
}

.slg-table tbody td {
  padding: 14px 16px;
  color: #e4e4e4;
  font-weight: 500;
  vertical-align: middle;
  word-break: break-word;
}

.slg-table tbody tr:hover {
  background-color: rgb(217 217 217 / 5%);
}

body.light_theme .slg-table tbody td {
  color: #101828;
}

.slg-timeCell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.slg-timeAbs {
  display: block;
}

.slg-timeRel {
  display: block;
  font-size: 12px;
  font-weight: 500;
  color: #8e939c;
  line-height: 1.3;
}

.slg-table tbody tr:last-child:not(.slg-table__emptyRow) td {
  border-bottom: none;
}

.slg-table__emptyRow td {
  border-bottom: none;
  padding: 0;
  vertical-align: middle;
}

.slg-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 56px 24px 56px;
  min-height: 280px;
}

.slg-empty img {
  filter: invert(1);
}

body.light_theme .slg-empty img {
  filter: invert(0);
}

.slg-page .spot_orders_empty_telescope {
  display: block;
  max-width: 120px;
  height: auto;
  margin: 0 auto 16px;
}

.slg-empty__text {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #9ca3af;
}


/* Third Party Access - unbind confirm modal (light + dark) */
.tpa-unbind-overlay {
  position: fixed;
  inset: 0;
  z-index: 12000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);
}

body.light_theme .tpa-unbind-overlay {
  background: rgb(255 255 255 / 20%);
}

.tpa-unbind-modal {
  position: relative;
  width: min(440px, 92vw);
  border-radius: 16px;
  padding: 28px 24px 22px;
  background: rgb(28 31 38 / 80%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.45);
  text-align: center;
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px);

}

body.light_theme .tpa-unbind-modal {
  background: rgb(255 255 255 / 20%);
  border: 1px solid #e5e7eb;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.18);
}

.tpa-unbind-modal__close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #9ca3af;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.tpa-unbind-modal__close:hover {
  color: #e4e4e4;
  background: rgba(255, 255, 255, 0.06);
}

body.light_theme .tpa-unbind-modal__close:hover {
  color: #101828;
  background: #f3f4f6;
}

.tpa-unbind-modal__title {
  margin: 4px 0 12px;
  font-size: 20px;
  font-weight: 600;
  color: #e4e4e4;
  letter-spacing: -0.01em;
}

body.light_theme .tpa-unbind-modal__title {
  color: #101828;
}

.tpa-unbind-modal__text {
  margin: 0 0 24px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: #9ca3af;
}

body.light_theme .tpa-unbind-modal__text {
  color: #667085;
}

.tpa-unbind-modal__actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.tpa-unbind-modal__btn {
  min-width: 120px;
  height: 42px;
  padding: 0 18px;
  border-radius: 999px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.tpa-unbind-modal__btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.tpa-unbind-modal__btn--cancel {
  background: #2a2e36;
  color: #e4e4e4;
}

.tpa-unbind-modal__btn--cancel:hover:not(:disabled) {
  background: #353a44;
}

body.light_theme .tpa-unbind-modal__btn--cancel {
  background: #eef0f3;
  color: #101828;
}

body.light_theme .tpa-unbind-modal__btn--cancel:hover:not(:disabled) {
  background: #e4e7ec;
}

.tpa-unbind-modal__btn--confirm {
  background: #d1aa67;
  color: #0c0d10;
}

.tpa-unbind-modal__btn--confirm:hover:not(:disabled) {
  background: #e0be2f;
}

body.light_theme .tpa-unbind-modal__btn--confirm {
  background: #2d2e32;
  color: #ffffff;
}

body.light_theme .tpa-unbind-modal__btn--confirm:hover:not(:disabled) {
  background: #1a1b1e;
}

.tpa-account-connections-link {
  display: inline;
  padding: 0;
  background: none;
  border: none;
  color: #bb934d;
  cursor: pointer;
}

/* Authorized devices */
.adv-sessionCard {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 0 0 20px;
  padding: 14px 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.03);
}

.adv-sessionCard--compact {
  margin-bottom: 16px;
}

body.light_theme .adv-sessionCard {
  border-color: #e4e7ec;
  background: #f9fafb;
}

.adv-sessionCard__main {
  display: flex;
  flex-direction: column;
  gap: 4px;
  color: #e4e4e4;
}

body.light_theme .adv-sessionCard__main {
  color: #101828;
}

.adv-sessionCard__meta,
.adv-muted {
  font-size: 12px;
  color: #8e939c;
  font-weight: 500;
}

.adv-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}

.adv-actions--end {
  justify-content: flex-end;
  margin-top: 14px;
}

.adv-btn {
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: transparent;
  color: #e4e4e4;
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.adv-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.adv-btn--primary {
  background: #d1aa67;
  border-color: #d1aa67;
  color: #0c0d10;
}

.adv-btn--danger {
  border-color: rgba(220, 80, 80, 0.5);
  color: #f3a4a4;
}

body.light_theme .adv-btn {
  border-color: #d0d5dd;
  color: #344054;
}

body.light_theme .adv-btn--danger {
  color: #b42318;
  border-color: #fecdca;
}

.adv-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.08);
  color: #c8cdd5;
}

.adv-badge--ok {
  background: rgba(209, 170, 103, 0.2);
  color: #d1aa67;
}

.adv-badge--danger {
  background: rgba(239, 68, 68, 0.16);
  color: #f97066;
}

.adv-modalOverlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  padding: 16px;
}

.adv-modal {
  width: 100%;
  max-width: 420px;
  border-radius: 12px;
  padding: 20px;
  background: #16181d;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

body.light_theme .adv-modal {
  background: #fff;
  border-color: #e4e7ec;
}

.adv-modal__title {
  margin: 0 0 8px;
  font-size: 18px;
  color: #e4e4e4;
}

body.light_theme .adv-modal__title {
  color: #101828;
}

.adv-modal__sub {
  margin: 0 0 12px;
  font-size: 13px;
  color: #8e939c;
}

.adv-modal__input {
  width: 100%;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: transparent;
  color: #e4e4e4;
  padding: 10px 12px;
}

body.light_theme .adv-modal__input {
  border-color: #d0d5dd;
  color: #101828;
}


@media (max-width: 991px) {

  .slg-table {
    min-width: 520px;
  }

  .slg-tab {
    margin-bottom: 10px;
  }

  .slg-page__title {
    font-size: 24px;
  }

  .security_section_bl {
    padding-top: 20px;
    padding-left: 0px;
  }

  .slg-page__crumbList {
    font-size: 14px;
  }

}

@media (max-width: 767px) {

  .slg-page__title {
    font-size: 20px;
  }

  .adv-actions {
    justify-content: end;
  }

  .security_section_bl {
    padding-top: 10px;
  }

  .tpa-unbind-modal {
    width: 100%;
  }

  .tpa-unbind-overlay {
    align-items: end;
    padding: 0px;
  }

  .tpa-unbind-modal {
    border-radius: 16px 16px 0px 0px;
  }

}

/* Security Logs, Third Party Access, etc.: mobile card layout (opt-in via .slg-tableWrap--mobileCards) */
@media (max-width: 991.98px) {
  .slg-tableWrap--mobileCards {
    overflow: visible;
    background: transparent;
  }

  .slg-tableWrap--mobileCards .slg-tableScroll {
    overflow-x: visible;
    -webkit-overflow-scrolling: touch;
  }

  .slg-tableWrap--mobileCards .slg-table {
    min-width: 0;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 12px;
    table-layout: fixed;
  }

  .slg-tableWrap--mobileCards .slg-table thead {
    display: none;
  }

  .slg-tableWrap--mobileCards .slg-table tbody {
    display: block;
    width: 100%;
  }

  .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) {
    display: block;
    width: 100%;
    background: #ffffff14;
    border: 1px solid #eef2f614;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);
    margin-bottom: 0;
    overflow: hidden;
    margin-bottom: 20px;
  }


  body.light_theme .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) {
    background: #fff;
    border: 1px solid #eef2f6;
  }

  .slg-tableWrap--mobileCards .slg-table tbody tr.slg-table__emptyRow {
    display: block;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  .slg-tableWrap--mobileCards .slg-table tbody tr.slg-table__emptyRow td {
    display: block;
    width: 100%;
    padding: 0;
    border: none;
  }

  .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) td[data-label] {
    display: flex;
    justify-content: space-between;
    align-items: start;
    column-gap: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #f1f5f90f;
  }

  body.light_theme .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) td[data-label] {
    border-bottom: 1px solid #f1f5f9;
  }

  .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) td[data-label]:last-child {
    border-bottom: none;
  }

  .slg-tableWrap--mobileCards .slg-table tbody td[data-label]::before {
    content: attr(data-label);
    font-size: 12px;
    font-weight: 500;
    white-space: nowrap;
    color: #94a3b8;
    grid-column: 1;
    padding-top: 2px;
  }

  .slg-tableWrap--mobileCards .slg-table tbody td[data-label] .slg-cardVal {
    grid-column: 2;
    display: block;
    text-align: right;
    justify-self: stretch;
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
    font-weight: 500;
    color: #f3f3f3;
  }

  body.light_theme .slg-tableWrap--mobileCards .slg-table tbody td[data-label] .slg-cardVal {
    color: #101828;
  }

  /* Third Party Access: long names read better left-aligned in the value column */
  .slg-tableWrap--mobileCards .slg-table tbody td[data-label="Third Party"] .slg-cardVal {
    text-align: left;
    justify-self: start;
  }


  .adv-sessionCard--compact {
    margin-top: 10px;
  }
}


@media (max-width: 480px) {

  .slg-tabs {
    gap: 12px;
  }

  .slg-tab {
    font-size: 13px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/TwofactorPage/securityLogs.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,OAAO;EACP,UAAU;EACV,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;;AAGA,6DAA6D;AAC7D;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,kCAA0B;UAA1B,0BAA0B;;AAE5B;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;;AAGA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gCAAgC;EAClC;;AAEF;;AAEA,yGAAyG;AACzG;EACE;IACE,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,mBAAmB;IACnB,6CAA6C;IAC7C,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;;EAGA;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA,gFAAgF;EAChF;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;;EAGA;IACE,gBAAgB;EAClB;AACF;;;AAGA;;EAEE;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* Security Logs — scoped .slg-* */\n\n.slg-page {\n  width: 100%;\n  min-height: 100%;\n  padding: 35px 24px 48px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.slg-page *,\n.slg-page *::before,\n.slg-page *::after {\n  box-sizing: border-box;\n}\n\n.slg-page__crumbs {\n  margin-bottom: 18px;\n}\n\n.slg-page__crumbList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: #8e939c;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.slg-page__crumbItem--active {\n  color: #e1e1e1;\n}\n\nbody.light_theme .slg-page__crumbItem--active {\n  color: #101828;\n}\n\n.security_section_bl {\n  padding-top: 40px;\n  padding-left: 30px;\n}\n\n.slg-page__crumbSep {\n  color: #8e939c;\n}\n\n.slg-page__crumbLink {\n  border: none;\n  background: transparent;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\n.slg-page__title {\n  margin: 0 0 20px;\n  font-size: 36px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #e4e4e4;\n}\n\nbody.light_theme .slg-page__title {\n  color: #101828;\n}\n\n.slg-page__sub {\n  margin: 0 0 20px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #8e939c;\n  line-height: 1.5;\n  max-width: 720px;\n}\n\n.slg-page__title+.slg-page__sub {\n  margin-top: -10px;\n}\n\n.slg-tabs {\n  display: flex;\n  gap: 32px;\n  margin-bottom: 0;\n}\n\n.slg-tab {\n  border: none;\n  background: transparent;\n  padding: 0 0 5px;\n  margin-bottom: 18px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #84888C;\n  cursor: pointer;\n  border-bottom: none;\n  position: relative;\n}\n\n.slg-tab::before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  width: 24px;\n  margin: 0 auto;\n  left: 0;\n  opacity: 0;\n  right: 0px;\n  height: 2px;\n  background: #fff;\n}\n\nbody.light_theme .slg-tab::before {\n  background: #101828;\n}\n\n.slg-tab:hover {\n  color: #6b7280;\n}\n\n.slg-tab.is-active {\n  color: #e6e6e6;\n  font-weight: 600;\n}\n\nbody.light_theme .slg-tab.is-active {\n  color: #101828;\n}\n\n.slg-tab.is-active::before {\n  opacity: 1;\n}\n\n.slg-tableWrap {\n  margin-top: 0;\n  background: #171a20;\n  overflow: hidden;\n}\n\nbody.light_theme .slg-tableWrap {\n  background: #fff;\n}\n\n.slg-tableScroll {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.slg-table {\n  width: 100%;\n  min-width: 880px;\n  border-collapse: collapse;\n  table-layout: auto;\n  font-size: 14px;\n}\n\n.slg-table thead th {\n  padding: 14px 16px 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 500;\n  color: #9ca3af;\n  letter-spacing: 0.02em;\n  text-transform: capitalize;\n  border-bottom: 1px solid #eef2f6;\n}\n\n.slg-table tbody td {\n  padding: 14px 16px;\n  color: #e4e4e4;\n  font-weight: 500;\n  vertical-align: middle;\n  word-break: break-word;\n}\n\n.slg-table tbody tr:hover {\n  background-color: rgb(217 217 217 / 5%);\n}\n\nbody.light_theme .slg-table tbody td {\n  color: #101828;\n}\n\n.slg-timeCell {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.slg-timeAbs {\n  display: block;\n}\n\n.slg-timeRel {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  color: #8e939c;\n  line-height: 1.3;\n}\n\n.slg-table tbody tr:last-child:not(.slg-table__emptyRow) td {\n  border-bottom: none;\n}\n\n.slg-table__emptyRow td {\n  border-bottom: none;\n  padding: 0;\n  vertical-align: middle;\n}\n\n.slg-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 56px 24px 56px;\n  min-height: 280px;\n}\n\n.slg-empty img {\n  filter: invert(1);\n}\n\nbody.light_theme .slg-empty img {\n  filter: invert(0);\n}\n\n.slg-page .spot_orders_empty_telescope {\n  display: block;\n  max-width: 120px;\n  height: auto;\n  margin: 0 auto 16px;\n}\n\n.slg-empty__text {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #9ca3af;\n}\n\n\n/* Third Party Access - unbind confirm modal (light + dark) */\n.tpa-unbind-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 12000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(5px);\n}\n\nbody.light_theme .tpa-unbind-overlay {\n  background: rgb(255 255 255 / 20%);\n}\n\n.tpa-unbind-modal {\n  position: relative;\n  width: min(440px, 92vw);\n  border-radius: 16px;\n  padding: 28px 24px 22px;\n  background: rgb(28 31 38 / 80%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.45);\n  text-align: center;\n  backdrop-filter: blur(5px);\n\n}\n\nbody.light_theme .tpa-unbind-modal {\n  background: rgb(255 255 255 / 20%);\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.18);\n}\n\n.tpa-unbind-modal__close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #9ca3af;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.tpa-unbind-modal__close:hover {\n  color: #e4e4e4;\n  background: rgba(255, 255, 255, 0.06);\n}\n\nbody.light_theme .tpa-unbind-modal__close:hover {\n  color: #101828;\n  background: #f3f4f6;\n}\n\n.tpa-unbind-modal__title {\n  margin: 4px 0 12px;\n  font-size: 20px;\n  font-weight: 600;\n  color: #e4e4e4;\n  letter-spacing: -0.01em;\n}\n\nbody.light_theme .tpa-unbind-modal__title {\n  color: #101828;\n}\n\n.tpa-unbind-modal__text {\n  margin: 0 0 24px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #9ca3af;\n}\n\nbody.light_theme .tpa-unbind-modal__text {\n  color: #667085;\n}\n\n.tpa-unbind-modal__actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.tpa-unbind-modal__btn {\n  min-width: 120px;\n  height: 42px;\n  padding: 0 18px;\n  border-radius: 999px;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.tpa-unbind-modal__btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.tpa-unbind-modal__btn--cancel {\n  background: #2a2e36;\n  color: #e4e4e4;\n}\n\n.tpa-unbind-modal__btn--cancel:hover:not(:disabled) {\n  background: #353a44;\n}\n\nbody.light_theme .tpa-unbind-modal__btn--cancel {\n  background: #eef0f3;\n  color: #101828;\n}\n\nbody.light_theme .tpa-unbind-modal__btn--cancel:hover:not(:disabled) {\n  background: #e4e7ec;\n}\n\n.tpa-unbind-modal__btn--confirm {\n  background: #d1aa67;\n  color: #0c0d10;\n}\n\n.tpa-unbind-modal__btn--confirm:hover:not(:disabled) {\n  background: #e0be2f;\n}\n\nbody.light_theme .tpa-unbind-modal__btn--confirm {\n  background: #2d2e32;\n  color: #ffffff;\n}\n\nbody.light_theme .tpa-unbind-modal__btn--confirm:hover:not(:disabled) {\n  background: #1a1b1e;\n}\n\n.tpa-account-connections-link {\n  display: inline;\n  padding: 0;\n  background: none;\n  border: none;\n  color: #bb934d;\n  cursor: pointer;\n}\n\n/* Authorized devices */\n.adv-sessionCard {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin: 0 0 20px;\n  padding: 14px 16px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.adv-sessionCard--compact {\n  margin-bottom: 16px;\n}\n\nbody.light_theme .adv-sessionCard {\n  border-color: #e4e7ec;\n  background: #f9fafb;\n}\n\n.adv-sessionCard__main {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  color: #e4e4e4;\n}\n\nbody.light_theme .adv-sessionCard__main {\n  color: #101828;\n}\n\n.adv-sessionCard__meta,\n.adv-muted {\n  font-size: 12px;\n  color: #8e939c;\n  font-weight: 500;\n}\n\n.adv-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n\n.adv-actions--end {\n  justify-content: flex-end;\n  margin-top: 14px;\n}\n\n.adv-btn {\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: transparent;\n  color: #e4e4e4;\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.adv-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.adv-btn--primary {\n  background: #d1aa67;\n  border-color: #d1aa67;\n  color: #0c0d10;\n}\n\n.adv-btn--danger {\n  border-color: rgba(220, 80, 80, 0.5);\n  color: #f3a4a4;\n}\n\nbody.light_theme .adv-btn {\n  border-color: #d0d5dd;\n  color: #344054;\n}\n\nbody.light_theme .adv-btn--danger {\n  color: #b42318;\n  border-color: #fecdca;\n}\n\n.adv-badge {\n  display: inline-block;\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.08);\n  color: #c8cdd5;\n}\n\n.adv-badge--ok {\n  background: rgba(209, 170, 103, 0.2);\n  color: #d1aa67;\n}\n\n.adv-badge--danger {\n  background: rgba(239, 68, 68, 0.16);\n  color: #f97066;\n}\n\n.adv-modalOverlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.55);\n  padding: 16px;\n}\n\n.adv-modal {\n  width: 100%;\n  max-width: 420px;\n  border-radius: 12px;\n  padding: 20px;\n  background: #16181d;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\nbody.light_theme .adv-modal {\n  background: #fff;\n  border-color: #e4e7ec;\n}\n\n.adv-modal__title {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: #e4e4e4;\n}\n\nbody.light_theme .adv-modal__title {\n  color: #101828;\n}\n\n.adv-modal__sub {\n  margin: 0 0 12px;\n  font-size: 13px;\n  color: #8e939c;\n}\n\n.adv-modal__input {\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: transparent;\n  color: #e4e4e4;\n  padding: 10px 12px;\n}\n\nbody.light_theme .adv-modal__input {\n  border-color: #d0d5dd;\n  color: #101828;\n}\n\n\n@media (max-width: 991px) {\n\n  .slg-table {\n    min-width: 520px;\n  }\n\n  .slg-tab {\n    margin-bottom: 10px;\n  }\n\n  .slg-page__title {\n    font-size: 24px;\n  }\n\n  .security_section_bl {\n    padding-top: 20px;\n    padding-left: 0px;\n  }\n\n  .slg-page__crumbList {\n    font-size: 14px;\n  }\n\n}\n\n@media (max-width: 767px) {\n\n  .slg-page__title {\n    font-size: 20px;\n  }\n\n  .adv-actions {\n    justify-content: end;\n  }\n\n  .security_section_bl {\n    padding-top: 10px;\n  }\n\n  .tpa-unbind-modal {\n    width: 100%;\n  }\n\n  .tpa-unbind-overlay {\n    align-items: end;\n    padding: 0px;\n  }\n\n  .tpa-unbind-modal {\n    border-radius: 16px 16px 0px 0px;\n  }\n\n}\n\n/* Security Logs, Third Party Access, etc.: mobile card layout (opt-in via .slg-tableWrap--mobileCards) */\n@media (max-width: 991.98px) {\n  .slg-tableWrap--mobileCards {\n    overflow: visible;\n    background: transparent;\n  }\n\n  .slg-tableWrap--mobileCards .slg-tableScroll {\n    overflow-x: visible;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table {\n    min-width: 0;\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 12px;\n    table-layout: fixed;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table thead {\n    display: none;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table tbody {\n    display: block;\n    width: 100%;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) {\n    display: block;\n    width: 100%;\n    background: #ffffff14;\n    border: 1px solid #eef2f614;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(15, 23, 42, 0.06);\n    margin-bottom: 0;\n    overflow: hidden;\n    margin-bottom: 20px;\n  }\n\n\n  body.light_theme .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) {\n    background: #fff;\n    border: 1px solid #eef2f6;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table tbody tr.slg-table__emptyRow {\n    display: block;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table tbody tr.slg-table__emptyRow td {\n    display: block;\n    width: 100%;\n    padding: 0;\n    border: none;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) td[data-label] {\n    display: flex;\n    justify-content: space-between;\n    align-items: start;\n    column-gap: 14px;\n    padding: 12px 16px;\n    border-bottom: 1px solid #f1f5f90f;\n  }\n\n  body.light_theme .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) td[data-label] {\n    border-bottom: 1px solid #f1f5f9;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table tbody tr:not(.slg-table__emptyRow) td[data-label]:last-child {\n    border-bottom: none;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table tbody td[data-label]::before {\n    content: attr(data-label);\n    font-size: 12px;\n    font-weight: 500;\n    white-space: nowrap;\n    color: #94a3b8;\n    grid-column: 1;\n    padding-top: 2px;\n  }\n\n  .slg-tableWrap--mobileCards .slg-table tbody td[data-label] .slg-cardVal {\n    grid-column: 2;\n    display: block;\n    text-align: right;\n    justify-self: stretch;\n    min-width: 0;\n    overflow-wrap: anywhere;\n    word-break: break-word;\n    font-weight: 500;\n    color: #f3f3f3;\n  }\n\n  body.light_theme .slg-tableWrap--mobileCards .slg-table tbody td[data-label] .slg-cardVal {\n    color: #101828;\n  }\n\n  /* Third Party Access: long names read better left-aligned in the value column */\n  .slg-tableWrap--mobileCards .slg-table tbody td[data-label=\"Third Party\"] .slg-cardVal {\n    text-align: left;\n    justify-self: start;\n  }\n\n\n  .adv-sessionCard--compact {\n    margin-top: 10px;\n  }\n}\n\n\n@media (max-width: 480px) {\n\n  .slg-tabs {\n    gap: 12px;\n  }\n\n  .slg-tab {\n    font-size: 13px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
